import datapoints from '../datapoints';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { ClientItem, mailStore } from 'owa-mail-store';

export default createLegacyActionWithDatapoint(
    'untranslateItem',
    datapoints.InlineTranslationMessageUntranslated
)(function untranslateItem(itemId: string) {
    const item: ClientItem = mailStore.items.get(itemId);
    const conversationId = item.ConversationId.Id;
    const conversationItemParts = mailStore.conversations.get(conversationId);
    conversationItemParts.subjectTranslationData.isShowingTranslation = false;
    item.TranslationData.isShowingTranslation = false;
});
